export default () => dispatch => {
    dispatch({
        type: 'TOGGLE_LOADING',
        payload: { isActive: false, text: "" }
    })
}